import { getAncestorWindowsAndSelfDepthFirst, isWindowSameOrigin } from '@/gr/common/utils/window/navigation';

export function refreshTopmostSameOriginWindow(): void {
  const targetWindow = getAncestorWindowsAndSelfDepthFirst(window)
    .reverse()
    .filter((w) => isWindowSameOrigin(w))[0];
  targetWindow.location.reload();
}
